module.exports = __webpack_public_path__ + "media/assets/images/blog/glossario_datafication-small-61c9c1863a72e79a05eaa8d2a1bcd3ab.png";